import StoredLayout from '../../layouts/StoredLayout'
import LineChartWidgets from './LineChartWidgets'
export default StoredLayout(LineChartWidgets)



// WEBPACK FOOTER //
// ./src/widgets/line-chart-widgets/index.js